import '../../App.scss';
import NewsTextBox from '../Atoms/NewsTextBox';
import Button from '../Atoms/Button';
import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { client } from '../../client';

class NewsItems extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);

    this.state = {
      newsData: []
      // title: [],
      // titleEnglish: '',
      // exhibitionPlace: '',
      // year: ''
    }  

  }

  //this is where we receive API calls inside components
  componentDidMount() {
    client.getEntries({
      content_type: "news",
      // order: '-sys.createdAt'
      order: "-fields.newsDate"
    })
      .then((response) => {
        console.log(response); // log the entire response object
        this.setState({
          //Slicing to get only 3 newest news
          newsData : response.items.slice(0,3)
        
        })
        
    })
    .catch(console.error)
  }
  
  

  render() {
    
    //TODO API CALL AND PASS DATA AS PROPS
    //TODO ROUTE NEWS TO INDIVIDUAL NEWS
    //TODO BUILD LAYOUT FOR INDIVIDUAL NEWS ITEM
    //TODO POPULATE INDIVIDUAL NEWS ITEM WITH CONTENT

    // console.log(this.state.newsData)
    // console.log(this.state.newsData[0].fields)

    
    
    return (
      <div className="flex w-85 news-items phone-w-62">
        
        {this.state.newsData.map((singleNewsData, index) => (
            <Link to={`/nyheder/${singleNewsData.sys.id}`} className="flex-1 flex news-item" key={index}>
                <NewsTextBox cx={`br bb w-100`} title={singleNewsData.fields.newsTitle} excerpt={singleNewsData.fields.newsExcerpt} date={singleNewsData.fields.newsDate} key={index} hoverType="bg-hover"/>
            </Link>
              )
              
        )}
      </div>
    
    );
  }
}


export default NewsItems;